import React, { useContext, useState } from 'react'
import ApiService from '../../services/ApiService'

import { ButtonsDiv, CloseDiv, CloseImg, Container, InviteButtonDiv, InviteButtonImage, InviteButtonText, HeaderDiv, HeaderText, InputDiv, InputAdminName, LabelCreate, TipParagraph, InputWrongParagraph } from './style'
import cross from '../../assets/addStockModal/cross.svg'
import paperPlane from '../../assets/assesses/paper-plane.svg'
import ModalContext from '../../contexts/ModalContext'
import UserContext from '../../contexts/UserContext'

const InviteNewAdmin:React.FC = () => {
  const { setModalActive } = useContext(ModalContext)
  const [email, setEmail] = useState('')
  const [error, setError] = useState(false)
  const [message, setMessage] = useState('')
  const { token, user } = useContext(UserContext)
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  const success = 'Convite enviado com sucesso!'
  const errorMsg = 'Falha ao enviar convite, tente novamente.'

  const inviteAdmin = async () => {
    try {
        await ApiService.admin.inviteNewAdmin(email)
        setMessage(success)
        setEmail('')
        setError(false)
    } catch (error: any) {
        setMessage(errorMsg)
        setError(true)
    }
  }
  
  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Convidar novo administrador</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
            <CloseImg src={cross} alt='Close tab'/>
        </CloseDiv>
      </HeaderDiv>
      <TipParagraph>
        Insira o email do usuário a ser convidado e enviaremos instruções para o cadastro de administrador.
      </TipParagraph>
      <InputDiv>
        <LabelCreate>Email</LabelCreate>
        <InputAdminName
          placeholder='Digite aqui'
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
      </InputDiv>
      {error ? (
        <InputWrongParagraph>
          {message}
        </InputWrongParagraph>
      ): (
        null
      )}
      <ButtonsDiv onClick={() => inviteAdmin()}>
        <InviteButtonDiv>
          <InviteButtonImage src={paperPlane} alt='Paper-plane icon'/>
          <InviteButtonText>Enviar convite</InviteButtonText>
        </InviteButtonDiv>
      </ButtonsDiv>
    </Container>
  )
}

export default InviteNewAdmin
